import { DataType, Form, FormOptions, Section, SelectOption } from '@globaleris/ui.library'
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  DialogTitle,
  makeStyles,
  useTheme
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { fetchClientContractsByID, getCustomerDomain } from '../../../../../../redux'
import {
  createComunication,
  fetchMasterComunicationsOptions
} from '../../../../../comunicationCenter/tabs/externals/comunicationExternals.service'
import { useSelector } from 'react-redux'
import {
  selectClientContracts,
  selectClientData
} from '../../../../../../redux/selectors/client.selectors'
import { fetchContractsBySubjectID } from '../../../../../contracts/contracts.service'
import { contractsListMapper } from '../../../../../commercial/commercials/commercials.mapper'

import { styles } from './createComunicationDialog.styles'

export interface CreateComunicationDialogProps {
  open: boolean
  setOpen: (open: boolean) => void
}

interface FormProps {
  comunication: number
  contract: number
  onSuccess: () => void
}

export const CreateComunicationDialog = ({ open, setOpen, onSuccess }) => {
  const [t] = useTranslation(['globalerisLibrary', 'comunicationExternals', 'enums'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const [formData, setFormData] = useState<FormProps>({} as FormProps)
  const [masterComunicationsOptions, setMasterComunicationsOptions] = useState<SelectOption[]>([])

  const clientData = useSelector(selectClientData)
  const contracts = useSelector(selectClientContracts)

  const contractsListOptions = contracts ? contractsListMapper(contracts) : []

  useEffect(() => {
    if (clientData?.id && !contracts) {
      fetchClientContractsByID(clientData.id)
    }
  }, [clientData])

  useEffect(() => {
    getMasterComunicationsOptions()
  }, [])

  const getMasterComunicationsOptions = async () => {
    await fetchMasterComunicationsOptions().then(response => {
      if (response.success) {
        setMasterComunicationsOptions(response?.data ?? [])
      }
    })
  }

  const formSections: Section[] = [
    {
      inputs: [
        {
          name: 'comunication',
          label: t('comunicationExternals:createComunicationDialog.inputs.comunication'),
          type: DataType.SELECT,
          selectOptions: masterComunicationsOptions,
          onChange: value => {
            setFormData(formData => ({ ...formData, comunication: +value }))
          }
        },
        {
          name: 'contract',
          label: t('comunicationExternals:createComunicationDialog.inputs.contract'),
          type: DataType.SELECT,
          selectOptions: contractsListOptions,
          onChange: value => {
            setFormData(formData => ({ ...formData, contract: +value }))
          }
        }
      ]
    }
  ]

  const handleSave = async () => {
    if (clientData?.id && formData.comunication && formData.contract) {
      return await createComunication(
        clientData?.id,
        formData?.comunication,
        formData?.contract
      ).then(response => {
        if (response.success) {
          onSuccess()
          setOpen(false)
          return true
        }
        return false
      })
    }
    return false
  }

  const formOptions: FormOptions = {
    elevation: 0,
    columns: 1,
    analytics: {
      customer: getCustomerDomain(),
      view: t('comunicationExternals:forms.mainActions.back.inputs.attached')
    }
  }

  return (
    <Dialog maxWidth={'md'} disableBackdropClick disableEscapeKeyDown open={open}>
      <DialogContent dividers>
        <Form
          title={t('comunicationExternals:createComunicationDialog.title')}
          subtitle={t('comunicationExternals:createComunicationDialog.subtitle')}
          sections={formSections}
          data={formData}
          options={formOptions}
        />
      </DialogContent>
      <DialogActions>
        <Button size="small" color="primary" onClick={() => setOpen(false)}>
          {t('comunicationExternals:createComunicationDialog.actions.cancel')}
        </Button>
        <Button size="small" color="primary" onClick={() => handleSave()}>
          {t('comunicationExternals:createComunicationDialog.actions.send')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

//className={classes.formWithOutToolbar}
